





























































































































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
export default Vue.extend({
  props: {
    categories: {
      type: Array as () => Array<ProductCategory>,
      required: true
    },
    categorySearchCount: {
      type: Object as () => { [key: string]: number },
      required: true
    }
  },
  data(): {
    activeMenu: string
    selectedGrandCategoryId: number | null
    selectedParentCategoryId: number | null
  } {
    return {
      activeMenu: '',
      selectedGrandCategoryId: null,
      selectedParentCategoryId: null
    }
  },
  computed: {
    parentCategories(): ProductCategory[] {
      const category = this.categories.find(
        item => item.id === this.selectedGrandCategoryId
      )
      return category?.childCategories || []
    },
    childCategories(): ProductCategory[] {
      const category = this.parentCategories.find(
        item => item.id === this.selectedParentCategoryId
      )
      return category?.childCategories || []
    }
  },
  methods: {
    onSelectGrandCategory(category: ProductCategory) {
      if (category.childCategories?.length > 0) {
        this.selectedGrandCategoryId = category.id
        this.activeMenu = 'parent_category'
      } else {
        this.updateSearchParam(category)
      }
    },
    onSelectParentCategory(category: ProductCategory) {
      if (category.childCategories?.length > 0) {
        this.selectedParentCategoryId = category.id
        this.activeMenu = 'child_category'
      } else {
        this.updateSearchParam(category)
      }
    },
    selectedParentCategoryLabel(): string {
      const item = this.parentCategories.find(
        item => item.id === this.selectedParentCategoryId
      )
      return item?.shortDisplayName || ''
    },
    updateSearchParam(category: ProductCategory) {
      this.$emit('onSelectCategory', {
        id: category.id,
        name: category.shortDisplayName
      })
      this.closeCategoryModal()
    },
    closeCategoryModal() {
      this.$emit('closeCategoryModal')
    }
  }
})
